import { NovelGroupClient } from "@/lib/clients";
import { NovelGroup } from "@/lib/models";
import { ActionContext, ActionTree, GetterTree, MutationTree, Store } from "vuex";

const novelGroupClient = new NovelGroupClient();

export interface NovelGroupState {
  groups: NovelGroup[];
}

type Getters = {
  groups(state: NovelGroupState): NovelGroup[];
};

const getters: GetterTree<NovelGroupState, {}> & Getters = {
  groups: (state) => state.groups,
};

const mutations: MutationTree<NovelGroupState> = {
  setGroups(state, payload: NovelGroup[]) {
    state.groups = payload;
  },
  addGroup(state, payload: NovelGroup) {
    state.groups = [payload, ...state.groups];
  },
  updateGroupInState(state, payload: NovelGroup) {
    state.groups = state.groups.map((g) => (g.groupId === payload.groupId ? payload : g));
  },
  removeGroup(state, groupId: string) {
    state.groups = state.groups.filter((g) => g.groupId !== groupId);
  },
};

type Actions = {
  initialize(this: Store<{}>, injectee: ActionContext<NovelGroupState, {}>): Promise<void>;
  createGroup(this: Store<{}>, injectee: ActionContext<NovelGroupState, {}>, payload: { name: string }): Promise<NovelGroup>;
  updateGroup(
    this: Store<{}>,
    injectee: ActionContext<NovelGroupState, {}>,
    payload: { groupId: string; name?: string; novelKeys?: string[] }
  ): Promise<NovelGroup>;
  deleteGroup(
    this: Store<{}>,
    injectee: ActionContext<NovelGroupState, {}>,
    payload: { groupId: string }
  ): Promise<void>;
};

const actions: ActionTree<NovelGroupState, {}> & Actions = {
  async initialize({ commit }) {
    try {
      const groups = await novelGroupClient.fetchAllGroups();
      commit("setGroups", groups);
    } catch (e) {
      // API未デプロイ等の場合は空配列のまま
    }
  },

  async createGroup({ commit }, payload): Promise<NovelGroup> {
    const group = await novelGroupClient.createGroup(payload.name);
    commit("addGroup", group);
    return group;
  },

  async updateGroup({ commit }, payload): Promise<NovelGroup> {
    const { groupId, ...updates } = payload;
    const group = await novelGroupClient.updateGroup(groupId, updates);
    commit("updateGroupInState", group);
    return group;
  },

  async deleteGroup({ commit }, payload): Promise<void> {
    await novelGroupClient.deleteGroup(payload.groupId);
    commit("removeGroup", payload.groupId);
  },
};

export default {
  namespaced: true,
  state: {
    groups: [],
  },
  getters,
  actions,
  mutations,
};
